// src/stores/consentStore.ts
import { defineStore } from 'pinia'
import { Consent, RequiredConsent } from '@/types'
import { useGlobalStore } from './global-store'
import { fetchUserRequiredConsents } from '@/api'

export const useConsentStore = defineStore('consent', {
  state: (): {
    requiredConsents: RequiredConsent[] | null
    consents: Consent[] | null
  } => ({
    requiredConsents: null,
    consents: null,
  }),
  getters: {
    getRequiredConsents: (state) => state.requiredConsents,
    getConsents: (state) => state.consents,
  },
  actions: {
    async loadRequiredConsents() {
      if (this.requiredConsents == null) {
        const globalStore = useGlobalStore()
        try {
          this.requiredConsents = await fetchUserRequiredConsents(globalStore.language)
        } catch (error: any) {
          console.log(error)
        }
      }
    },
    clear() {
      this.requiredConsents = null
      this.consents = null
    },
  },
  persist: {
    storage: localStorage,
  },
})
